<template>
  <v-card class="pa-3 px-0 mt-4">
    <v-card-title class="text-h5 font-weight-bold pt-0 px-3 pb-2">
      <v-toolbar flat dense>
        <v-toolbar-title class="text-h5 font-weight-bold"> Viber </v-toolbar-title>
        <v-spacer />
        <v-btn v-if="superUser && !editing" icon @click="editing = true">
          <v-icon>mdi-pencil-outline</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="4">
          <div class="text-caption font-weight-medium">
            {{ translations.viber_transaction[lang] }}
          </div>
          <div v-if="!editing">{{ displayValue(viberCost?.transaction) }}</div>
          <v-text-field
            v-else
            v-model.number="form.transaction"
            type="number"
            dense
            :error-messages="errors.transaction"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <div class="text-caption font-weight-medium">
            {{ translations.viber_promotional[lang] }}
          </div>
          <div v-if="!editing">{{ displayValue(viberCost?.promotional) }}</div>
          <v-text-field
            v-else
            v-model.number="form.promotional"
            type="number"
            dense
            :error-messages="errors.promotional"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <div class="text-caption font-weight-medium">
            {{ translations.viber_monthly_fee[lang] }}
          </div>
          <div v-if="!editing">{{ displayValue(viberCost?.monthly_fee) }}</div>
          <v-text-field
            v-else
            v-model.number="form.monthly_fee"
            type="number"
            dense
            :error-messages="errors.monthly_fee"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row v-if="editing">
        <v-col class="d-flex" cols="12">
          <v-btn color="secondary" class="mr-2" @click="save">{{ translations.save[lang] }}</v-btn>
          <v-btn text @click="cancel">{{ translations.cancel[lang] }}</v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import translations from '@/utils/translations/general/settings/billingDashboard';
import chargesValidator from '@/utils/validators/general/settings/billingDashboard/charges';

export default {
  name: 'BillingChargesViber',
  mixins: [translations, chargesValidator],

  data() {
    return {
      editing: false,
      form: {
        transaction: null,
        promotional: null,
        monthly_fee: null,
      },
      errors: {
        transaction: '',
        promotional: '',
        monthly_fee: '',
      },
    };
  },

  computed: {
    ...mapState(['superUser']),
    ...mapState('general/settings/billingDashboard/charges', ['viberCost', 'loading']),

    lang() {
      return this.$route.params.lang;
    },
  },

  methods: {
    ...mapActions('general/settings/billingDashboard/charges', ['getViberCost', 'updateViberCost']),

    displayValue(val) {
      return val === null || val === undefined ? '-' : val;
    },

    async save() {
      this.errors = { transaction: '', promotional: '', monthly_fee: '' };
      const fields = ['transaction', 'promotional', 'monthly_fee'];
      let hasError = false;

      for (const field of fields) {
        if (!this.validateCost(this.form[field])) {
          this.errors[field] = this.error.cost;
          hasError = true;
        }
      }
      if (hasError) return;

      const originalForm = { ...this.form };
      try {
        const body = {
          viber_cost: {
            transaction: Number(this.form.transaction),
            promotional: Number(this.form.promotional),
            monthly_fee: Number(this.form.monthly_fee),
          },
        };
        const res = await this.updateViberCost(body);
        if (res && !res.error) {
          this.$store.commit('setNotification', {
            show: true,
            type: 'success',
            text: this.translations.success[this.lang] + 'Viber',
          });
          this.editing = false;
        } else {
          this.form = { ...originalForm };
          this.$store.commit('setNotification', {
            show: true,
            type: 'error',
            text: res?.message || 'Failed to update Viber cost',
          });
        }
      } catch (e) {
        this.form = { ...originalForm };
        this.$store.commit('setNotification', {
          show: true,
          type: 'error',
          text: 'Failed to update Viber cost',
        });
      }
    },

    cancel() {
      this.editing = false;
      this.errors = { transaction: '', promotional: '', monthly_fee: '' };
      this.syncForm();
    },

    syncForm() {
      this.form.transaction = this.viberCost?.transaction ?? null;
      this.form.promotional = this.viberCost?.promotional ?? null;
      this.form.monthly_fee = this.viberCost?.monthly_fee ?? null;
    },
  },

  watch: {
    '$store.state.storeId': {
      async handler(val) {
        if (val) {
          await this.getViberCost();
          this.syncForm();
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped></style>
